var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-vote-button"},[(_vm.href !== '')?_c('a',{staticClass:"base-vote-button__element",class:{
      'has-icon-left': _vm.hasIconLeft,
      'has-icon-right': _vm.hasIconRight,
    },attrs:{"href":_vm.href,"target":_vm.targetBlank ? '_blank' : '_self'}},[_vm._t("default",function(){return [_vm._v("Text")]})],2):(_vm.to !== '')?_c('router-link',{staticClass:"base-vote-button__element",class:{
      'has-icon-left': _vm.hasIconLeft,
      'has-icon-right': _vm.hasIconRight,
    },attrs:{"to":_vm.to}},[_vm._t("default",function(){return [_vm._v("Text")]})],2):_c('button',{staticClass:"base-vote-button__element",class:{
      'has-icon-left': _vm.hasIconLeft,
      'has-icon-right': _vm.hasIconRight,
      'is-loading': _vm.loading,
    },attrs:{"disabled":_vm.disabled,"type":_vm.type,"role":"button"}},[_vm._t("default",function(){return [_vm._v("Text")]}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"base-vote-button__loader"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }